<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.banks.show") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <div v-if="!isBankLoading">
        <form @submit.prevent="validateFormInputs">
          <div class="row">
            <!-- Start:: Name Input -->
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.nameAr')"
              v-model.trim="data.name_ar"
              disabled
            />
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.nameEn')"
              v-model.trim="data.name_en"
              disabled
            />
            <!-- End:: Name Input -->
            <!-- Start:: Deactivate Switch Input -->
            <div class="input_wrapper switch_wrapper my-5 col-6">
              <v-switch
                color="green"
                :label="
                  data.active
                    ? $t('PLACEHOLDERS.active')
                    : $t('PLACEHOLDERS.notActive')
                "
                v-model="data.active"
                hide-details
                disabled
              ></v-switch>
            </div>
            <!-- End:: Deactivate Switch Input -->
          </div>
        </form>
      </div>
      <div v-else class="d-flex justify-content-center my-5">
        <v-progress-circular
          indeterminate
          color="#3eb6d4"
          :size="40"
        />
      </div>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ShowBank",

  
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      isBankLoading: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        name_ar: null,
        name_en: null,
        count_use: null,
        active: null,
      

},
      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    // start show data
    async showBank() {
      try {
        this.isBankLoading = true;
        let res = await this.$axios({
          method: "GET",
          url: `banks/${this.$route.params?.id}`,
        });
        this.data.name_ar = res.data.data.Bank.name_ar;
        this.data.name_en = res.data.data.Bank.name_en;
        this.data.active = res.data.data.Bank.is_active;
      } catch (error) {
        console.log(error?.response?.data?.message);
      } finally {
        this.isBankLoading = false;
      }
    },
    // end show data
  },

  created() {
    this.showBank();
  },
};
</script>
